import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { checkToken } from '../helpers/helperFunctions';
import { logos, icons, MAIL_FORMATTING } from "../helpers/constants";
import Button from '../components/Buttons/Button';
import LanguagePicker from '../components/LanguagePicker';
import * as request from "../services/FetchService";
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '../helpers/customHooks';
import { useContextData } from '../components/ContextData'; // Adjust the path as necessary
import toast from 'react-hot-toast';
import NewButton from '../components/Buttons/NewButton';
import { toggleTheme } from "../assets/css/theme";
import { AnimatePresence, motion } from "framer-motion";


const ForgotPassword = (props) => {
    const MOBILE = useIsMobile();
    const navigate = useNavigate()
	const { t } = useTranslation();
    const [email, setEmail] = useState("")
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [errorEmail, setErrorEmail] = useState("")
    const [tema, setTema] = useState(
        () => document.documentElement.getAttribute("data-theme") || "light"
    );
    const [outerShowLang, setOuterShowLang] = useState(false);
    const [onHover, setOnHover] = useState(false);
    const onToggleTheme = () => {
        const curr = toggleTheme()
        setTema(curr)
    }
    const darkmodeIconSrc = tema === "dark" ? icons.sun : icons.moon;
    const handleChange = (type, e) => {
        if(type === "email"){
            setErrorEmail("")
            if(MAIL_FORMATTING.test(e.target.value)){
                setInvalidEmail(false)
            }else{
                setInvalidEmail(true)
            }
            setEmail(e.target.value)
        }
    }

    const resetPass = (e) => {
        e.preventDefault();

        const cleanedEmail = email.trim();

        if (cleanedEmail === "" || invalidEmail) {
            setErrorEmail(t("login.invalid_email"));
            return;
        }

        const obj = {
            email: cleanedEmail,
            language: localStorage.getItem("language") || "en"
        };

        request.post("", "forgotpassword/sendresetlink", obj).then((response) => {
            if (response.data.successful) {
                toast.success(t("toast.success"));
            } else {
                toast.error(response.data.message);
            }
        });
    };

    return(
        <>
        <div className="d-flex flex-column loginfield mx-auto px-3 px-md-0">
            <div className='d-flex align-self-end gap-3'>
                {process.env.REACT_APP_ASSETS === "swetrack" &&		
                    <img onClick={onToggleTheme} src={darkmodeIconSrc} className={`grey-blue-icon position-relative cursor-pointer size_20 align-self-center`} alt="..." />
                }
                <div className="d-flex align-items-center justify-items-center">
                    <div className="position-relative">
                        <LanguagePicker outerShowLang={outerShowLang} />
                    </div>
                    <motion.div onClick={() => setOuterShowLang(!outerShowLang)} className="label cursor-pointer" initial={false} animate={{ maxWidth: onHover ? 999 : 0, x: onHover ? 0 : -8 }}>
                        <span className="fw-bold">{t("sidebar.language")}</span>
                    </motion.div>
                </div>
            </div>
            <NewButton 
            notext={true} 
            icon={icons.chevron_left}
            iconClass={"grey-blue-icon"}
            className={`position-absolute my-auto ms-2 border-sm bg-white full-rounded size_36 p-3`} 
            onClick={() => navigate("/login")}/>
            
            <img src={logos.big} className="login_logo mx-auto" alt="logo"/>
            <h3 className="text-center mt-5">{t("login.forgot_password")}</h3>
            <p className="text-center mt-3">{t("login.forgot_password_sub")}</p>
            <form onSubmit={(e) => resetPass(e)} className="h-100 d-flex flex-column">
                <div className="form-group mt-3">
                    <p className="bold">{t("login.email")}</p>
                    <input
                        type="email"
                        placeholder=""
                        className={`form-control rounded16 p-3 ${errorEmail === "" ? "" : "error-border"}`}
                        name="email"
                        value={email}
                        onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                resetPass(e)
                                e.preventDefault();// Prevent the default Enter key behavior
                                //document.getElementById("password").focus()
                                }
                            }}
                    />
                    <div className="d-flex justify-content-between position-relative">
                        <p className="red bold position-absolute mt-1">{errorEmail === "" ? " " : errorEmail}</p>
                    </div>
                </div>
                <NewButton className="bg-gradient white-white bold w-100 rounded16 p-3 mt-auto mt-md-5 mb-3" onClick={(e) => resetPass(e)}>{t("login.reset_password")}</NewButton>
            </form>
        </div>
        </>
    )
    
    return(
        <>   
        <div className="container-fluid h-100">
            <div className="d-flex justify-content-center h-100">
                <div className={`d-flex flex-column col-10 col-md-6 col-xl-4 loginfield`}>
                <div className="d-flex position-relative">
                    <Button className="position-absolute my-auto" icon={icons.back} notext={true} onClick={() => navigate("/login")}/>
                    <img className="login_logo mx-auto mb-5" src={logos.big} alt="logo"/>
                </div>
                <h1>{t("login.forgot_password")}</h1>
                <p>{t("login.forgot_password_sub")}</p>
                <form onSubmit={(e) => resetPass(e)}>
                    <div className="form-floating form-floating-group flex-grow-1 is-valid mb-5">
                        <input
                            type="email"
                            placeholder="0"
                            id="email"
                            className="form-control login-input-field pe-4"
                            name="email"
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                resetPass(e)
                                }
                            }}
                        />
                        <img className={`position-absolute end-0 bottom-0 mb-2 ${email === "" ? "d-none" : ""}`} src={invalidEmail ? icons.cross : icons.check} alt=""/>
                        <label htmlFor="floatingInput">
                            {t("login.email_placeholder")}
                        </label>
                        <div className="invalid-feedback ms-1 bottom">
                            {errorEmail === "" ? "" : errorEmail}
                        </div>
                    </div>
                    <Button btnClass="btn-primary w-100" onClick={(e) => resetPass(e)}>{t("login.reset_password")}</Button>
                </form>
            </div>
        </div>
        </div>
        <div className={`position-absolute left-0 bottom-0 ${MOBILE ? "ms-2 mb-2" : "ms-5 mb-5"} bg-grey cursor-pointer rounded`}>
            <LanguagePicker />
        </div>
        </>
    )
}

export default ForgotPassword;